import { filterRecommendationProducts } from 'lib/utils/recommendation-eligibility'
import { useState, useEffect } from 'react'
import ProductsApiHandler from 'lib/api/products'
import { SEGMENT_RECOMMENDATION_QUERY_ID } from 'lib/segment/const'

function useRecommendation(productId) {
  const [result, setResult] = useState(null)

  useEffect(() => {
    let ignore = false

    async function fetchRecommends() {
      try {
        const res = await ProductsApiHandler.getRecommendsByProduct(productId)
        if (ignore) return
        setResult({
          productId,
          products: filterRecommendationProducts(res?.products),
        })
        if (res?.id_recommendation != null)
          sessionStorage.setItem(
            SEGMENT_RECOMMENDATION_QUERY_ID,
            res.id_recommendation,
          )
      } catch (error) {
        if (!ignore) {
          setResult({ productId, products: [] })
        }
      }
    }

    fetchRecommends()

    return () => {
      ignore = true
    }
  }, [productId])

  return result && result.productId === productId
    ? [result.products, true]
    : [undefined, false]
}

export default useRecommendation
